/**
 * CrampEase Landing Page — crampease-lp.js
 * Place in: Assets/crampease-lp.js
 *
 * Handles:
 *  1. Image gallery swipe + controls
 *  2. Variant selection + price update
 *  3. Quantity stepper
 *  4. Add to cart (AJAX)
 *  5. Sticky bar show/hide on scroll
 *  6. FAQ accordion
 *  7. Smooth scroll CTAs
 */
 
(function () {
  'use strict';
 
  /* ── Utility ── */
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];
  const money = (cents) => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
  };
 
  /* ═══════════════════════════════════════════
     1. IMAGE GALLERY
  ═══════════════════════════════════════════ */
  (function initGallery() {
    const track  = $('#ce2GalleryTrack');
    const prev   = $('#ce2GalleryPrev');
    const next   = $('#ce2GalleryNext');
    const dotsWr = $('#ce2GalleryDots');
    if (!track) return;
 
    const items = $$('.ce2-gallery__item', track);
    const count = items.length;
    if (count < 2) return;
 
    let current = 0;
 
    function goTo(n) {
      current = (n + count) % count;
      track.style.transform = `translateX(-${current * 100}%)`;
      $$('.ce2-gallery__dot', dotsWr).forEach((d, i) => {
        d.classList.toggle('is-active', i === current);
      });
    }
 
    if (prev) prev.addEventListener('click', () => goTo(current - 1));
    if (next) next.addEventListener('click', () => goTo(current + 1));
 
    if (dotsWr) {
      dotsWr.addEventListener('click', (e) => {
        const dot = e.target.closest('[data-index]');
        if (dot) goTo(parseInt(dot.dataset.index, 10));
      });
    }
 
    /* Touch swipe */
    let startX = 0;
    track.addEventListener('touchstart', (e) => { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', (e) => {
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });
  })();
 
  /* ═══════════════════════════════════════════
     2. VARIANT SELECTION
  ═══════════════════════════════════════════ */
  (function initVariants() {
    const pills    = $$('.ce2-pill');
    const varInput = $('#ce2-variant-id');
    const priceEl  = $('#ce2-price');
    const compareEl= $('#ce2-compare');
    const badgeEl  = $('#ce2-buybox .ce2-buybox__badge');
    const atcText  = $('#ce2-atc-text');
    const stickyPr = $('#ce2StickyPrice');
    const closePrice = $('#ce2-close-price');
 
    if (!pills.length || !varInput) return;
 
    /* Build option state from pills */
    const optionState = {};
 
    pills.forEach((pill) => {
      pill.addEventListener('click', () => {
        const optionIdx = pill.dataset.option;
        const value     = pill.dataset.value;
 
        /* Update label */
        const labelEl = $(`#ce2-option-val-${optionIdx}`);
        if (labelEl) labelEl.textContent = value;
 
        /* Toggle active within this option group */
        $$(`[data-option="${optionIdx}"]`).forEach((p) => p.classList.remove('is-active'));
        pill.classList.add('is-active');
 
        optionState[optionIdx] = value;
 
        /* Try to find matching variant */
        updateVariant();
      });
    });
 
    function updateVariant() {
      if (typeof window.__ce2Variants === 'undefined') return;
 
      const selectedValues = Object.values(optionState);
      const match = window.__ce2Variants.find((v) => {
        return v.options.every((opt, i) => !selectedValues[i] || opt === selectedValues[i]);
      });
 
      if (!match) return;
 
      varInput.value = match.id;
 
      const priceText  = money(match.price);
      const compareCents = match.compare_at_price;
 
      if (priceEl)    priceEl.textContent    = priceText;
      if (stickyPr)   stickyPr.textContent   = priceText;
      if (atcText)    atcText.textContent    = `Add to cart — ${priceText}`;
 
      if (closePrice) {
        closePrice.innerHTML = priceText;
        if (compareCents && compareCents > match.price) {
          closePrice.innerHTML += ` <span class="ce2-close__compare">${money(compareCents)}</span>`;
        }
      }
 
      if (compareEl) {
        if (compareCents && compareCents > match.price) {
          compareEl.textContent = money(compareCents);
          compareEl.style.display = '';
          if (badgeEl) {
            const pct = Math.round((compareCents - match.price) * 100 / compareCents);
            badgeEl.textContent = `Save ${pct}%`;
            badgeEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none';
          if (badgeEl) badgeEl.style.display = 'none';
        }
      }
 
      /* Unavailable state */
      $$('.ce2-pill').forEach((p) => p.classList.remove('is-unavailable'));
      if (!match.available) {
        const atcBtn = $('#ce2-atc');
        if (atcBtn) {
          atcBtn.disabled = true;
          const t = $('#ce2-atc-text');
          if (t) t.textContent = 'Sold out';
        }
      }
    }
  })();
 
  /* ═══════════════════════════════════════════
     3. QUANTITY STEPPER
  ═══════════════════════════════════════════ */
  (function initQty() {
    const minus = $('#ce2-minus');
    const plus  = $('#ce2-plus');
    const input = $('#ce2-qty');
    if (!input) return;
 
    minus && minus.addEventListener('click', () => {
      const v = parseInt(input.value, 10);
      if (v > 1) input.value = v - 1;
    });
 
    plus && plus.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  })();
 
  /* ═══════════════════════════════════════════
     4. ADD TO CART (AJAX)
  ═══════════════════════════════════════════ */
  (function initATC() {
    const form    = $('#ce2-form');
    const btn     = $('#ce2-atc');
    const btnText = $('#ce2-atc-text');
    const btnLoad = $('#ce2-atc-loading');
    if (!form || !btn) return;
 
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
 
      const variantId = parseInt($('#ce2-variant-id').value, 10);
      const quantity  = parseInt($('#ce2-qty').value, 10) || 1;
      if (!variantId) return;
 
      /* Loading state */
      btn.disabled  = true;
      btn.classList.add('is-loading');
      if (btnText) btnText.style.display = 'none';
      if (btnLoad) btnLoad.style.display = '';
 
      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variantId, quantity }),
        });
 
        if (!res.ok) throw new Error('Add to cart failed');
 
        /* Success — open cart or redirect */
        if (window.Shopify && window.Shopify.onItemAdded) {
          window.Shopify.onItemAdded();
        } else {
          /* Open mini-cart if theme has it, otherwise go to /cart */
          const cartDrawerToggle = document.querySelector('[data-cart-toggle], .cart-toggle, .js-cart-toggle');
          if (cartDrawerToggle) {
            cartDrawerToggle.click();
          } else {
            window.location.href = '/cart';
          }
        }
 
      } catch (err) {
        console.error('CrampEase ATC error:', err);
        /* Reset on error */
        btn.disabled  = false;
        btn.classList.remove('is-loading');
        if (btnText) btnText.style.display = '';
        if (btnLoad) btnLoad.style.display = 'none';
      }
    });
  })();
 
  /* ═══════════════════════════════════════════
     5. STICKY BAR
  ═══════════════════════════════════════════ */
  (function initSticky() {
    const bar    = $('#ce2StickyBar');
    const buyBox = $('#ce2-buy');
    const stickyBtn = $('#ce2StickyBtn');
    if (!bar || !buyBox) return;
 
    /* Show sticky bar once buy box scrolls out of view */
    const observer = new IntersectionObserver(
      ([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
        bar.setAttribute('aria-hidden', String(entry.isIntersecting));
      },
      { threshold: 0 }
    );
    observer.observe(buyBox);
 
    /* Sticky btn scrolls back to buy box */
    if (stickyBtn) {
      stickyBtn.addEventListener('click', () => {
        buyBox.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  })();
 
  /* ═══════════════════════════════════════════
     6. FAQ ACCORDION
  ═══════════════════════════════════════════ */
  (function initFAQ() {
    $$('.ce2-faq__btn').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        const panel    = btn.nextElementSibling;
        if (!panel) return;
 
        /* Close all others */
        $$('.ce2-faq__btn').forEach((b) => {
          b.setAttribute('aria-expanded', 'false');
          const p = b.nextElementSibling;
          if (p) p.classList.remove('is-open');
        });
 
        /* Toggle current */
        if (!expanded) {
          btn.setAttribute('aria-expanded', 'true');
          panel.classList.add('is-open');
        }
      });
    });
  })();
 
  /* ═══════════════════════════════════════════
     7. SMOOTH SCROLL for anchor CTAs
  ═══════════════════════════════════════════ */
  (function initSmoothScroll() {
    $$('a[href^="#"]').forEach((link) => {
      link.addEventListener('click', (e) => {
        const target = document.querySelector(link.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  })();
 
})();